import { useSelector } from 'react-redux';
import { State } from 'store/types';

export const isEligibleForDifferentialPricing = (state: State) => {
  let isDifferentialPricingEnabled = false;
  try {
    isDifferentialPricingEnabled =
      state.remoteConfig.switches.differentialPricingEnabled;
  } catch (error) {
    console.error('Error checking differential pricing eligibility:', error);
  }
  return isDifferentialPricingEnabled;
};

export const useIsDifferentialPricingEnabled = () => {
  const state = useSelector((state: State) => state);
  return isEligibleForDifferentialPricing(state);
};
